import { useTranslation } from 'react-i18next';

// Components
import TableRowMX from '../TableRowMX';
import TableRowMobileMX from '../TableRowMobileMX';

// Styles
import styles from './index.module.sass';

type Props = {
  order: Object,
  getOrder: Function,
  device: Object,
};

export default function OrderTable({ order = {}, getOrder, device }: Props): React$Node {
  const { t } = useTranslation('order');
  const tableTitles = t('tableTitles', { returnObjects: true });

  const orderDetail = order?.detallePedido || [];

  const screenSize = device?.screenSize || 'desktop';
  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      {screenSize !== 'phone' && (
        <div className={styles.header}>
          <div className={`${styles.column} ${styles.product}`}>{tableTitles[0]}</div>
          {/* <div className={`${styles.column} ${styles.actionsTitle}`}>Acciones</div> */}
          <div className={`${styles.column} ${styles.uni}`}>{tableTitles[1]}</div>
          <div className={`${styles.column} ${styles.letter}`}>{tableTitles[2]}</div>
          <div className={`${styles.column} ${styles.price}`}>{tableTitles[3]}</div>
          <div className={`${styles.column}`}>{tableTitles[4]}</div>
          <div className={`${styles.column}`}>{tableTitles[5]}</div>
        </div>
      )}
      <div className={styles.tableData}>
        {orderDetail.map((val, key) => {
          return (
            (screenSize === 'phone' && (
              <TableRowMobileMX node={val} key={key} device={device} getOrder={getOrder} />
            )) || <TableRowMX node={val} key={key} device={device} getOrder={getOrder} />
          );
        })}
      </div>
    </div>
  );
}
